import { Layout, Menu, Breadcrumb } from "antd";
import React from "react";
import { VideoPlayer } from "../../components";
import "./FinebiPlay.less";
import { Link, useParams, NavLink, useHistory } from "react-router-dom";
import axios from "axios";
import { useState, useEffect } from "react";
import { LeftOutlined } from "@ant-design/icons";
import PlayNoIcon from "../../assets/images/play_no.png";
import PlayIcon from "../../assets/images/play.png";
const { Header, Footer, Sider, Content } = Layout;
const { SubMenu } = Menu;
const rootSubmenuKeys = [
  "sub1",
  "sub2",
  "sub3",
  "sub4",
  "sub5",
  "sub6",
  "sub7",
];

const FinebiPlay = (props) => {
  let { id } = useParams();

  const history = useHistory();
  const [videos, setVideos] = useState({
    29: {
      index: "1.1",
      description:
        "本章將帶你瞭解FineBI 產品定位、產品優勢、產品架構、產品功能",
      doclink: "https://help.fanruan.com/finebi/doc-view-259.html",
      video_title: "FineBI産品簡介",
    },
    30: {
      index: "1.2",
      description:
        "本章將帶你瞭解FineBI 產品定位、產品優勢、產品架構、產品功能",
      doclink: "https://help.fanruan.com/finebi/doc-view-259.html",
      video_title: "FineBI産品簡介",
    },
    31: {
      index: "1.3",
      description:
        "本章將帶你瞭解FineBI 產品定位、產品優勢、產品架構、產品功能",
      doclink: "https://help.fanruan.com/finebi/doc-view-259.html",
      video_title: "FineBI産品簡介",
    },
    32: {
      index: "2.1",
      description:
        "本章將帶你瞭解資料上傳和資料更新的操作，透過案例演示掌握資料分析的第一步——資料準備",
      doclink: "https://help.fanruan.com/finebi/doc-view-1622.html",
      video_title: "連接到數據",
    },
    33: {
      index: "2.2",
      description:
        "本章將帶你瞭解資料上傳和資料更新的操作，透過案例演示掌握資料分析的第一步——資料準備",
      doclink: "https://help.fanruan.com/finebi/doc-view-1622.html",
      video_title: "連接到數據",
    },
    34: {
      index: "3.1",
      description:
        "本章將帶你瞭解使用FineBI自助資料集來完成原始資料的預處理，以提升資料分析質量",
      doclink: "https://help.fanruan.com/finebi/doc-view-1633.html",
      video_title: "使用自助數據集做數據處理",
    },
    35: {
      index: "3.2",
      description:
        "本章將帶你瞭解使用FineBI自助資料集來完成原始資料的預處理，以提升資料分析質量",
      doclink: "https://help.fanruan.com/finebi/doc-view-1633.html",
      video_title: "使用自助數據集做數據處理",
    },
    36: {
      index: "4.1",
      description:
        "本章將帶你瞭解FineBI多維分析，透過對資料進行調整、處理，使其更滿足資料呈現的需求",
      doclink: "https://help.fanruan.com/finebi/doc-view-1623.html",
      video_title: "創建組件和分析數據",
    },
    37: {
      index: "4.2",
      description:
        "本章將帶你瞭解FineBI多維分析，透過對資料進行調整、處理，使其更滿足資料呈現的需求",
      doclink: "https://help.fanruan.com/finebi/doc-view-1623.html",
      video_title: "創建組件和分析數據",
    },
    38: {
      index: "4.3",
      description:
        "本章將帶你瞭解FineBI多維分析，透過對資料進行調整、處理，使其更滿足資料呈現的需求",
      doclink: "https://help.fanruan.com/finebi/doc-view-1623.html",
      video_title: "創建組件和分析數據",
    },
    39: {
      index: "5.1",
      description: "本章將透過圖表的選擇和製作帶你掌握視覺化分析技巧",
      doclink: "https://help.fanruan.com/finebi/doc-view-1626.html",
      video_title: "可視化組件",
    },
    40: {
      index: "5.2",
      description: "本章將透過圖表的選擇和製作帶你掌握視覺化分析技巧",
      doclink: "https://help.fanruan.com/finebi/doc-view-1626.html",
      video_title: "可視化組件",
    },
    41: {
      index: "5.3",
      description: "本章將透過圖表的選擇和製作帶你掌握視覺化分析技巧",
      doclink: "https://help.fanruan.com/finebi/doc-view-1626.html",
      video_title: "可視化組件",
    },
    42: {
      index: "6.1",
      description:
        "本章將帶你瞭解FineBI交互效果，透過多組件協同以滿足實際複雜業務場景的分析需求",
      doclink: "https://help.fanruan.com/finebi/doc-view-1629.html",
      video_title: "添加交互效果",
    },
    43: {
      index: "6.2",
      description:
        "本章將帶你瞭解FineBI交互效果，透過多組件協同以滿足實際複雜業務場景的分析需求",
      doclink: "https://help.fanruan.com/finebi/doc-view-1629.html",
      video_title: "添加交互效果",
    },
    44: {
      index: "6.3",
      description:
        "本章將帶你瞭解FineBI交互效果，透過多組件協同以滿足實際複雜業務場景的分析需求",
      doclink: "https://help.fanruan.com/finebi/doc-view-1629.html",
      video_title: "添加交互效果",
    },
    45: {
      index: "7.1",
      description: "本章將帶你瞭解儀表板的整體佈局和美化，以及儀表板分享的內容",
      doclink: "https://help.fanruan.com/finebi/doc-view-1632.html",
      video_title: "儀表板制作和分享",
    },
    46: {
      index: "7.2",
      description: "本章將帶你瞭解儀表板的整體佈局和美化，以及儀表板分享的內容",
      doclink: "https://help.fanruan.com/finebi/doc-view-1632.html",
      video_title: "儀表板制作和分享",
    },
    47: {
      index: "7.3",
      description: "本章將帶你瞭解儀表板的整體佈局和美化，以及儀表板分享的內容",
      doclink: "https://help.fanruan.com/finebi/doc-view-1632.html",
      video_title: "儀表板制作和分享",
    },
  });
  const [videolist, setVideoList] = useState({
    1: [
      {
        title: "1.1FineBI基本介紹",
        link: "29",
      },
      {
        title: "1.2啟動企業版FineBI",
        link: "30",
      },
      {
        title: "1.3FineBI5分鐘快速入門",
        link: "31",
      },
    ],
    2: [
      {
        title: "2.1連接資料庫表",
        link: "32",
      },
      {
        title: "2.2上傳excel資料集",
        link: "33",
      },
    ],
    3: [
      {
        title: "3.1多表合併",
        link: "34",
      },
      {
        title: "3.2編輯自助資料集",
        link: "35",
      },
    ],
    4: [
      {
        title: "4.1什麼是分組表",
        link: "36",
      },
      {
        title: "4.2調整數值格式",
        link: "37",
      },
      {
        title: "4.3表格快速計算",
        link: "38",
      },
    ],
    5: [
      {
        title: "5.1如何選擇圖表",
        link: "39",
      },
      {
        title: "5.2製作餅圖",
        link: "40",
      },
      {
        title: "5.3製作自定義圖表",
        link: "41",
      },
    ],
    6: [
      {
        title: "6.1組件鑽取",
        link: "42",
      },
      {
        title: "6.2過濾組件",
        link: "43",
      },
      {
        title: "6.3組件間聯動",
        link: "44",
      },
    ],
    7: [
      {
        title: "7.1儀錶板佈局",
        link: "45",
      },
      {
        title: "7.2儀錶板美化",
        link: "46",
      },
      {
        title: "7.3儀錶板分享",
        link: "47",
      },
    ],
  });
  const [videotime, setVideTime] = useState({});
  const [list, setList] = useState(1);
  const [title, setTitle] = useState("finebi_basiclearning video");
  const [videodata, setVideoData] = useState({
    sources: {
      src: "",
      type: "video/mp4",
    },
  });
  const [openKeys, setOpenKeys] = React.useState([]);
  const option = {
    autoplay: true,
    controls: true,
    responsive: true,
    fluid: true,
  };
  useEffect(() => {
    async function fetchData() {
      const result = await axios({
        method: "get",
        url: process.env.REACT_APP_API + "/view/video",
        params: {
          id: id,
        },
      });
      const videodata = await result.data;
      return videodata;
    }
    fetchData().then((res) => {
      setVideoData({
        sources: {
          src: res.it618_videourl,
          type: "video/mp4",
        },
      });
      setList(res.it618_lid - 4);
      setTitle(res.it618_name);
      setOpenKeys(["sub" + (res.it618_lid - 13)]);
      document.title = title;
    });
  }, [id, list]);
  useEffect(() => {
    async function fetchData() {
      const result = await axios({
        method: "get",
        url: process.env.REACT_APP_API + "/view/bi_tree",
      });
      const videolist = await result.data;
      return videolist;
    }
    fetchData().then((res) => {});
  }, [videolist]);

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    console.log(latestOpenKey);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };
  let dom = "";
  function handleClick() {
    history.push("/finebi_basiclearning");
  }
  if (videodata.sources.src !== "") {
    dom = (
      <div style={{ width: "1200px", margin: "0 auto" }}>
        <Layout style={{ fontSize: "16px" }}>
          <Sider
            width={300}
            className="site-layout-background"
            breakpoint="lg"
            collapsedWidth="0"
            onBreakpoint={(broken) => {}}
            onCollapse={(collapsed, type) => {}}
            style={{ height: "100%" }}
          >
            <div className="breadcrumb">
              <Breadcrumb separator=">">
                <Breadcrumb.Item
                  onClick={handleClick}
                  style={{ cursor: "pointer" }}
                >
                  教學影片
                </Breadcrumb.Item>
                <Breadcrumb.Item>FineBI 基礎教學</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <Menu
              mode="inline"
              style={{ height: "100%", borderRight: 0, fontSize: "16px" }}
              openKeys={openKeys}
              onOpenChange={onOpenChange}
              defaultSelectedKeys={videos[id]["index"]}
            >
              <SubMenu key="sub1" title="第一章 FineBI基本介紹">
                {videolist["1"].map((item, index) => {
                  return (
                    <Menu.Item
                      key={"1." + (index + 1)}
                      icon={
                        videos[id]["index"] === "1." + (index + 1) ? (
                          <img src={PlayIcon} alt="play" />
                        ) : (
                          <img src={PlayNoIcon} alt="play" />
                        )
                      }
                      style={{ paddingLeft: "24px" }}
                    >
                      <NavLink
                        to={{
                          pathname: `/finebi_basiclearning/${item.link}`,
                        }}
                      >
                        {item.title}
                      </NavLink>
                    </Menu.Item>
                  );
                })}
              </SubMenu>
              <SubMenu key="sub2" title="第二章 連接到資料">
                {videolist["2"].map((item, index) => {
                  return (
                    <Menu.Item
                      key={"2." + (index + 1)}
                      icon={
                        videos[id]["index"] === "2." + (index + 1) ? (
                          <img src={PlayIcon} alt="play" />
                        ) : (
                          <img src={PlayNoIcon} alt="play" />
                        )
                      }
                      style={{ paddingLeft: "24px" }}
                    >
                      <NavLink
                        to={{
                          pathname: `/finebi_basiclearning/${item.link}`,
                        }}
                      >
                        {item.title}
                      </NavLink>
                    </Menu.Item>
                  );
                })}
              </SubMenu>
              <SubMenu key="sub3" title="第三章 使用自助資料集做資料處理">
                {videolist["3"].map((item, index) => {
                  return (
                    <Menu.Item
                      key={"3." + (index + 1)}
                      icon={
                        videos[id]["index"] === "3." + (index + 1) ? (
                          <img src={PlayIcon} alt="play" />
                        ) : (
                          <img src={PlayNoIcon} alt="play" />
                        )
                      }
                      style={{ paddingLeft: "24px" }}
                    >
                      <NavLink
                        to={{
                          pathname: `/finebi_basiclearning/${item.link}`,
                        }}
                      >
                        {item.title}
                      </NavLink>
                    </Menu.Item>
                  );
                })}
              </SubMenu>
              <SubMenu key="sub4" title="第四章 創建組件並分析資料">
                {videolist["4"].map((item, index) => {
                  return (
                    <Menu.Item
                      key={"4." + (index + 1)}
                      icon={
                        videos[id]["index"] === "4." + (index + 1) ? (
                          <img src={PlayIcon} alt="play" />
                        ) : (
                          <img src={PlayNoIcon} alt="play" />
                        )
                      }
                      style={{ paddingLeft: "24px" }}
                    >
                      <NavLink
                        to={{
                          pathname: `/finebi_basiclearning/${item.link}`,
                        }}
                      >
                        {item.title}
                      </NavLink>
                    </Menu.Item>
                  );
                })}
              </SubMenu>
              <SubMenu key="sub5" title="第五章 視覺化組件">
                {videolist["5"].map((item, index) => {
                  return (
                    <Menu.Item
                      key={"5." + (index + 1)}
                      icon={
                        videos[id]["index"] === "5." + (index + 1) ? (
                          <img src={PlayIcon} alt="play" />
                        ) : (
                          <img src={PlayNoIcon} alt="play" />
                        )
                      }
                      style={{ paddingLeft: "24px" }}
                    >
                      <NavLink
                        to={{
                          pathname: `/finebi_basiclearning/${item.link}`,
                        }}
                      >
                        {item.title}
                      </NavLink>
                    </Menu.Item>
                  );
                })}
              </SubMenu>
              <SubMenu key="sub6" title="第六章 添加交互效果">
                {videolist["6"].map((item, index) => {
                  return (
                    <Menu.Item
                      key={"6." + (index + 1)}
                      icon={
                        videos[id]["index"] === "6." + (index + 1) ? (
                          <img src={PlayIcon} alt="play" />
                        ) : (
                          <img src={PlayNoIcon} alt="play" />
                        )
                      }
                      style={{ paddingLeft: "24px" }}
                    >
                      <NavLink
                        to={{
                          pathname: `/finebi_basiclearning/${item.link}`,
                        }}
                      >
                        {item.title}
                      </NavLink>
                    </Menu.Item>
                  );
                })}
              </SubMenu>
              <SubMenu key="sub7" title="第七章 儀表板分享">
                {videolist["7"].map((item, index) => {
                  return (
                    <Menu.Item
                      key={"7." + (index + 1)}
                      icon={
                        videos[id]["index"] === "7." + (index + 1) ? (
                          <img src={PlayIcon} alt="play" />
                        ) : (
                          <img src={PlayNoIcon} alt="play" />
                        )
                      }
                      style={{ paddingLeft: "24px" }}
                    >
                      <NavLink
                        to={{
                          pathname: `/finebi_basiclearning/${item.link}`,
                        }}
                      >
                        {item.title}
                      </NavLink>
                    </Menu.Item>
                  );
                })}
              </SubMenu>
            </Menu>
          </Sider>
          <Layout style={{ paddingLeft: "40px" }} className="videoright">
            <Header className="videoheader">
              <h1>
                {videos[id] ? videos[id]["index"] : ""}
                {title}
              </h1>
              <div className="headerbg">
                <p>
                  課程簡介: {videos[id] ? videos[id]["description"] : "无简介"}
                </p>
              </div>
            </Header>
            <Content>
              {/* https://twmarket.obs.ap-southeast-3.myhuaweicloud.com/video/finemobile.mp4 */}
              <VideoPlayer {...videodata} {...option} />
            </Content>
            <div className="footer">
              <div onClick={handleClick} className="backhome">
                <LeftOutlined style={{ marginRight: "5px" }} />
                返回課程頁面
              </div>
              <div>
                幫助文檔：
                <a
                  href={
                    videos[id]
                      ? videos[id]["doclink"]
                      : "https://help.fanruan.com/finereport-tw"
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  {videos[id].video_title}
                </a>
              </div>
            </div>
          </Layout>
        </Layout>
      </div>
    );
  }
  return dom;
};

export default FinebiPlay;
